import { Routes } from '@angular/router';
import { AppLayoutComponent } from './shared/components/app-layout/app-layout.component';
import { StepActivationGuard } from './shared/guards/step-activation.guard';
import {
  PROTECTION_PATH,
  SUBSCRIBER_PATH,
  QUOTE_CONFIRMATION_PATH,
  DIRECT_DEBIT_PATH,
  SPECIAL_CONDITIONS_PATH,
  CONFIRMATION_PATH,
  CONTRACT_VALIDATION_PATH,
  ROOT_PATH,
  SUBSCRIPTION_PATH,
  CONTEXT_PATH,
  PRODUCT_PATH,
  START_CONTEXT_PATH,
  START_CONTEXT_PRODUCT_PATH,
  SIGNATURE_STATUS_PATH,
  E_SIGN_MSG_STATUS_PATH,
  ERROR_404_PATH,
  CROSS_SELLING_W_PATH,
  CROSS_SELLING_C_PATH,
  OFFER_CUSTOMIZE_PATH,
  ADDRESS_PATH,
  ADDITIONAL_COVERAGE_PATH,
  PHYSICAL_PERSON_PATH,
  VEHICLE_PATH,
  TEMP_COMPONENT_TO_DELETE_PATH,
  DRIVER_PATH,
  SUPPORTING_DOCUMENT_PATH
} from './shared/constants/route.constants';
import { ProductGuard } from './shared/guards/product.guard';
import { ContextGuard } from './shared/guards/context.guard';
import { RedirectComponent } from './shared/components/redirect/redirect.component';
import { RedirectGuard } from './shared/guards/redirect.guard';
import { environment } from 'src/environments/environment';
import { StartGuard } from './shared/guards/start.guard';
import { ESignMsgComponent } from './views/process/options/e-sign-msg/e-sign-msg.component';
import { Error404Component } from './shared/components/error404/error404.component';

export const route_mobility: Routes = [
  {
    path: PROTECTION_PATH,
    loadComponent: () =>
      import(
        './views/process/options/protection/protection.component'
      ).then(m => m.ProtectionComponent),
    canActivate: [StepActivationGuard]
  },
  {
    path: ADDRESS_PATH,
    loadComponent: () =>
      import(
        './views/process/options/address/address.component'
      ).then(m => m.AddressComponent),
    canActivate: [StepActivationGuard]
  },
  {
    path: ADDITIONAL_COVERAGE_PATH,
    loadComponent: () =>
      import(
        './views/process/options/additional-coverage/additional-coverage.component'
      ).then(m => m.AdditionalCoverageComponent),
    canActivate: [StepActivationGuard]
  },
  {
    path: PHYSICAL_PERSON_PATH,
    loadComponent: () =>
      import('./views/process/options/physical-person/physical-person.component').then(
        m => m.PhysicalPersonComponent
      ),
    canActivate: [StepActivationGuard]
  },
  {
    path: VEHICLE_PATH,
    loadComponent: () =>
      import('./views/process/options/vehicle/vehicle.component').then(
        m => m.VehicleComponent
      ),
    canActivate: [StepActivationGuard]
  },
  {
    path: DRIVER_PATH,
    loadComponent: () =>
      import('./views/process/options/driver/driver.component').then(
        m => m.DriverComponent
      ),
    canActivate: [StepActivationGuard]
  },
   {
    path: SUPPORTING_DOCUMENT_PATH,
    loadComponent: () =>
      import('./views/process/options/supporting-document/supporting-document.component').then(
        m => m.SupportingDocumentComponent
      ),
    canActivate: [StepActivationGuard]
  },
  {
    path: SUBSCRIBER_PATH,
    loadComponent: () =>
      import('./views/process/options/subscriber/subscriber.component').then(
        m => m.SubscriberComponent
      ),
    canActivate: [StepActivationGuard]
  },
  {
    path: OFFER_CUSTOMIZE_PATH,
    loadComponent: () =>
      import(
        './views/process/options/offer-customize/offer-customize.component'
      ).then(m => m.OfferCustomizeComponent),
    canActivate: [StepActivationGuard]
  },
  {
    path: QUOTE_CONFIRMATION_PATH,
    loadComponent: () =>
      import(
        './views/process/options/quote-confirmation/quote-confirmation.component'
      ).then(m => m.QuoteConfirmationComponent),
    canActivate: [StepActivationGuard]
  },
  {
    path: DIRECT_DEBIT_PATH,
    loadComponent: () =>
      import('./views/process/options/direct-debit/direct-debit.component').then(
        m => m.DirectDebitComponent
      ),
    canActivate: [StepActivationGuard]
  },
  {
    path: SPECIAL_CONDITIONS_PATH,
    loadComponent: () =>
      import(
        './views/process/options/special-conditions/special-conditions.component'
      ).then(m => m.SpecialConditionsComponent),
    canActivate: [StepActivationGuard]
  },
  {
    path: CONFIRMATION_PATH,
    loadComponent: () =>
      import('./views/process/options/confirmation/confirmation.component').then(
        m => m.ConfirmationComponent
      ),
    canActivate: [StepActivationGuard]
  },
  {
    path: CROSS_SELLING_W_PATH,
    loadComponent: () =>
      import('./views/process/options/cross-selling/cross-selling.component').then(
        m => m.CrossSellingComponent
      ),
    canActivate: [StepActivationGuard]
  },
  {
    path: CROSS_SELLING_C_PATH, // Requires to have two different paths to differentiate W and C channels steps
    loadComponent: () =>
      import('./views/process/options/cross-selling/cross-selling.component').then(
        m => m.CrossSellingComponent
      ),
    canActivate: [StepActivationGuard]
  },
  {
    path: CONTRACT_VALIDATION_PATH,
    loadComponent: () =>
      import(
        './views/process/options/contract-validation/contract-validation.component'
      ).then(m => m.ContractValidationComponent),
    canActivate: [StepActivationGuard]
  }
];

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'product/' + environment.product,
    pathMatch: 'full'
  },
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      {
        path: SUBSCRIPTION_PATH,
        loadComponent: () =>
          import('./views/process/subscription/subscription.component').then(
            m => m.SubscriptionComponent
          ),
        children: route_mobility // or route_legal_protection
      },
      {
        path: START_CONTEXT_PRODUCT_PATH,
        canActivate: [RedirectGuard],
        component: RedirectComponent
      },
      {
        path: START_CONTEXT_PATH,
        canActivate: [RedirectGuard],
        component: RedirectComponent
      },
      {
        path: CONTEXT_PATH,
        canActivate: [ContextGuard],
        component: RedirectComponent
      },
      {
        path: PRODUCT_PATH,
        canActivate: [ProductGuard],
        component: RedirectComponent
      },
      {
        path: SIGNATURE_STATUS_PATH,
        canActivate: [StartGuard],
        component: RedirectComponent
      },
      {
        path: E_SIGN_MSG_STATUS_PATH,
        component: ESignMsgComponent
      },
      {
        path: ERROR_404_PATH,
        component: Error404Component
      },
      {
        path: '**',
        redirectTo: SUBSCRIPTION_PATH + ROOT_PATH + PROTECTION_PATH
      }
    ]
  }
];
